import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

/**
 * The worker caches nothing (see public/sw.js) — registering one is simply Chrome's
 * price of admission for `beforeinstallprompt`, and without that event Android gets no install
 * offer at all.
 *
 * After `load`, so it never competes with the first render for bandwidth, and swallowed on failure:
 * an origin without HTTPS (or a browser with workers disabled) means no install prompt, not a
 * broken app.
 */
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {})
  })
}
